import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import { companyAnalysisQueryKeys } from "app/pages/sales-intelligence/modules/company-analysis/queries/queryKeyFactory";
import type { GeoBreakdown } from "app/pages/sales-intelligence/modules/company-analysis/types/geo-breakdown";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

export const useGeoBreakdownQuery = (domain: string): UseQueryResult<GeoBreakdown[]> => {
    return useQuery({
        queryKey: companyAnalysisQueryKeys.geoBreakdown(domain),
        queryFn: async ({ signal }) => {
            return await salesApiService.companyAnalysis.fetchGeoBreakdown(domain, { cancellation: signal });
        },
    });
};
